import React, { PureComponent } from 'react';

class ObtenerAjusteCargoMotivo extends PureComponent {
    constructor(props) {
        super(props);
    }

    componentDidMount() {
        $('[data-toggle="tooltip"]').tooltip();
    }
    componentDidUpdate() {
        $('[data-toggle="tooltip"]').tooltip();
    }

    render() {
        const { destildarTildarCheckFiltroAjusteCargo, movFiltrado  } = this.props;
        let textoTooltip = "", codigoDescripcion = "";

        if (movFiltrado && movFiltrado.CodigoDescripcion.length > 36) {
            textoTooltip = movFiltrado.CodigoDescripcion;
            codigoDescripcion = movFiltrado.CodigoDescripcion.substr(0, 36);
            codigoDescripcion = codigoDescripcion + "...";
        } else {
            codigoDescripcion = movFiltrado.CodigoDescripcion;
        }

        return (<li className="inlineListItem">
            <div className="btn-group" data-toggle="tooltip" key={movFiltrado.ID} data-title={textoTooltip} data-placement="right">
                <button type="button" className="btn-tag btn-tag-closable btn-tag-closable-left not-clickable">{codigoDescripcion}</button>
                <button type="button" className="btn-tag btn-tag-closable btn-tag-closable-right"
                    onClick={() => destildarTildarCheckFiltroAjusteCargo(movFiltrado.ID, true)}>
                    <span key={movFiltrado.ID}
                        className="ti-close span-closable color-white"
                        title="Quitar Motivo" />
                </button>
            </div>
        </li>);
    }
}
export default ObtenerAjusteCargoMotivo;